var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcOpenMap = function SvgIcOpenMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    fill: "#E3F1F9",
    stroke: "#CADAE3",
    rx: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#025382",
    d: "m30.355 12.278-6.667-2.222h-.078a.777.777 0 0 0-.155 0H22.977l-6.311 2.167-6.311-2.167a1.111 1.111 0 0 0-1 .155 1.112 1.112 0 0 0-.467.9v15.556a1.111 1.111 0 0 0 .756 1.056l6.666 2.222c.224.073.466.073.69 0l6.333-2.111L29.643 30c.119.016.238.016.356 0 .233.004.46-.07.645-.21a1.11 1.11 0 0 0 .466-.9V13.333a1.11 1.11 0 0 0-.755-1.056Zm-14.8 15.067-4.445-1.478V12.656l4.445 1.478v13.21Zm6.666-1.478-4.444 1.478V14.134l4.444-1.478v13.211Zm6.667 1.478-4.444-1.478V12.656l4.444 1.478v13.21Z"
  })));
};
export default SvgIcOpenMap;